import { Navigate } from 'react-router-dom'
import { useAuthState } from '../AuthProvider'
import { useRole } from '../../providers/RoleProvider'
import LoadingOverlay from '../../components/LoadingOverlay'

export default function SecretaryRoute({ children }: any) {
  const { isAuthenticated, isLoading: authLoading } = useAuthState()
  const { role, loading: roleLoading } = useRole()

  if (authLoading || roleLoading) {
    return <LoadingOverlay />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />
  }

  if (role === null || role === 'doctor') {
    return <Navigate to="/dashboard" />
  }

  return children
}
